import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors, rt) => ({
  container: {
    flex: 1,
  },

  flatListContent: {
    paddingTop: theme.spacing[8],
    paddingHorizontal: theme.spacing[5],
    paddingBottom: rt.insets.bottom + theme.spacing[4],
    gap: theme.spacing[4],
  },
  fixedCategoryContent: {
    paddingTop: theme.spacing[5],
  },
  viewOrderBarPadding: {
    paddingBottom: 80,
  },

  sectionTitle: {
    marginBottom: theme.spacing[3],
  },

  addonsSectionTitle: {
    marginTop: theme.spacing[5],
    marginBottom: theme.spacing[3],
  },

  elevatedServiceCard: {
    marginBottom: theme.spacing[2],
  },

  sectionDivider: {
    height: 1,
    backgroundColor: colors.borderPrimary,
    marginVertical: theme.spacing[6],
  },

  otherServicesTitle: {
    marginBottom: theme.spacing[4],
  },

  categorySection: {
    marginBottom: theme.spacing[6],
  },

  gridSection: {
    flex: 1,
  },

  emptyStateContainer: {
    flex: 1,
    gap: theme.spacing[5],
    justifyContent: 'center',
    alignItems: 'center',
    paddingVertical: theme.spacing[8],
  },

  emptyStateIcon: {
    marginBottom: theme.spacing[6],
    opacity: 0.6,
  },

  emptyStateTitle: {
    textAlign: 'center',
    marginBottom: theme.spacing[3],
    color: colors.textPrimary,
  },

  emptyStateMessage: {
    textAlign: 'center',
    color: colors.textSecondary,
    lineHeight: 22,
  },

  errorContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: theme.spacing[6],
    paddingVertical: theme.spacing[8],
  },

  errorIcon: {
    marginBottom: theme.spacing[6],
    opacity: 0.6,
  },

  errorTitle: {
    textAlign: 'center',
    marginBottom: theme.spacing[3],
    color: colors.textNegative,
  },

  errorMessage: {
    textAlign: 'center',
    color: colors.textSecondary,
    lineHeight: 22,
  },
}));
